import React, {useLayoutEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import MissingPublicProductsManagementView from "./missing-products";
import TransactionsTroubleShootingView from "./transactions";
import useAccessLevels from "../../../../hooks/use-access-levels";

const DamageControlViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * With each change in the location:
     * - if the location is [routes.shippingFees.base] then changes it to [routes.shippingFees.list]
     * - if the location is [routes.customer.shippingFees.base] then changes it to [routes.customer.shippingFees.list]
     */
    useLayoutEffect(() => {
        if (matchPath(location.pathname, {path: routes.damageControl.base, exact: true})) {
            if (operatorAccessLevels.packages.lookup.missingPublicProductsList) {
                return history.replace(routes.damageControl.missingProducts);
            } else if (operatorAccessLevels.packages.sales.troubleshootTransactionsList) {
                return history.replace(routes.damageControl.transactions);
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.lookup.missingPublicProductsList, operatorAccessLevels.packages.sales.troubleshootTransactionsList]);

    return (
        <>
            <Switch>
                <Route path={routes.damageControl.base} exact/>
                {
                    operatorAccessLevels.packages.lookup.missingPublicProductsList &&
                    <Route path={routes.damageControl.missingProducts} exact>
                        <MissingPublicProductsManagementView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.troubleshootTransactionsList &&
                    <Route path={routes.damageControl.transactions} exact>
                        <TransactionsTroubleShootingView/>
                    </Route>
                }
                <Redirect to={routes.damageControl.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>

        </>
    )
}

export default DamageControlViews;
